import { createMachine } from '@atlassian/state-machine';

import { currentConnectionStatus } from '@canvas/canvas-state';
import { type BoardSyncStatus } from '@canvas/model/network';

import { createBoardSyncStateMachineConfig } from './board-sync-state-machine-config';

//TODO: remove useInitializeBoardSyncMachine and replace
//createBoardSyncStateMachine with createBoardSyncStateMachineV2
//when the standalone mode gets removed
export const createBoardSyncStateMachineV2 = () => {
  const config = createBoardSyncStateMachineConfig();
  const stateMachine = createMachine(config);

  currentConnectionStatus.boardSyncStatus = stateMap[stateMachine.state()];

  return stateMachine;
};

const stateMap: Record<string, BoardSyncStatus> = {
  unknown: 'saved',
  readOnlyDiscarded: 'editToViewOfflineChangesDiscarded',
  readOnly: 'editToViewAccess',
  edit: 'viewToEditAccess',
  synced: 'saved',
  syncing: 'saving',
};
